import React from 'react';

import { getAppEnv } from '@/config/app-env';

import { base_path } from '../../../environment';

interface Image {
  className?: string;
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  id?: string;
  style?: React.CSSProperties;
  isBackend?: boolean;
  onClick?: () => void;
}

const ImageWithBasePath = (props: Image) => {
  const apiBaseURL = getAppEnv().backendApi.url;
  const fullPublicSrc = `${base_path}${props.src}`;
  const fullServerSrc = `${apiBaseURL}/${props.src}`;
  const fullSrc = props.isBackend ? fullServerSrc : fullPublicSrc;

  return (
    <img
      className={props.className}
      src={fullSrc}
      height={props.height}
      alt={props.alt}
      width={props.width}
      id={props.id}
      style={props.style}
      onClick={props.onClick}
    />
  );
};

export default ImageWithBasePath;
